import Game from './scenes/Game';

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [Game],

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: Game.KEY,

  CURRENT_TOOL: 'draw',
  DRAW_COLOR: '0x000000',
  DRAW_SIZE: 'small',
  GAME_ORIENTATION: 'Landscape'
};
